module.exports = __webpack_public_path__ + "img/slider-1.39bbfb78.jpg";